import type { ScenariaPlan } from "src/model/model";

export interface GenerationEstimate {
  sceneCount: number;
  imageCount: number;
}

// Honest static count derived client-side from the plan (D7, Phase 3 step 4).
// `imageCount` = image360 scenes when Blockade is on, else 0 (video360 scenes
// have no Blockade pipeline). Pure — no wall-time math here; the "typically
// X–Y min" copy lives in the locale (parallel submissions mean count barely
// moves wall time, OQ2).
export const computeGenerationEstimate = (
  plan: ScenariaPlan | undefined,
  blockadeEnabled: boolean,
): GenerationEstimate => {
  const scenes = plan?.sceneOutline ?? [];
  const sceneCount = scenes.length;
  const imageCount = blockadeEnabled
    ? scenes.filter((scene) => scene.mediaType === "image360").length
    : 0;
  return { sceneCount, imageCount };
};
